(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('FontManagement', FontManagement);

    FontManagement.$inject = ['$resource'];

    function FontManagement ($resource) {
        var resourceUrl =  'bunny/' + 'api/font-managements/:path/:id';

        return $resource(resourceUrl, {}, {
            "fontSupport":{
                method:"GET",
                params:{
                    path:"font-support"
                }
            },
            "getDefaultShow":{
                method:"GET",
                params:{
                    path:"getDefaultShow"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "upload": {
                method: "POST",
                params: {
                    path: "upload"
                }
            },
            "getAll": {
                method: "POST",
                params: {
                    path: "getAll"
                },
                isArray: true
            },
            "getAll2": {
                method: "POST",
                params: {
                    path: "getAll2"
                },
                isArray: true
            },
            "getAll3": {
                method: "GET",
                params: {
                    path: "getAll3"
                },
                isArray: true
            },
            "updateType": {
                method: "GET",
                params: {
                    path: "updateType"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            "getCss": {
                method: "GET",
                params: {
                    path: "getCss2"
                }
            },
            "getFormat": {
                method: "GET",
                params: {
                    path: "getFormat"
                }
            },
            "batchDelete": {
                method: "DELETE",
                params: {
                    path: "batchDelete"
                }
            },
        });
    }
})();
